import { defineStore } from "pinia";
import { BotsService, CreateBot, ResponseBot, UpdateBot } from "../../services/bots/bots.service";
import { BotsAcoesService, ConteudoBotAcaoMidia, CreateBotsAcoes, TipoBotAcao } from "../../services/bots-acoes/bots-acoes.service";
import { StorageService } from "../admin/storage";
import { IdBot, IdConta, IdInbox } from "@/services/common-types";

export const useBotsStore = defineStore('bots', {
  state: () => ({
    initialized: false as boolean,
    botsService: new BotsService(),
    botsAcoesService: new BotsAcoesService(),
    storageService: new StorageService(),
    idConta: null as IdConta | null,
    bots: [] as ResponseBot[]
  }),

  actions: {
    async init(idConta: IdConta) {
      if (this.idConta && this.idConta == idConta) return;

      this.idConta = idConta;

      await this.getAll();

      this.initialized = true;
    },

    async create(dto: CreateBot) {
      const novoBot = await this.botsService.create(dto);

      if (!novoBot) return;

      this.bots.push(novoBot);

      return novoBot;
    },

    async update(dto: UpdateBot) {
      const updatedBot = await this.botsService.update(dto);

      const idx = this.bots.findIndex(b => b.id == dto.id);

      this.bots[idx] = updatedBot as unknown as ResponseBot;

      return updatedBot;
    },

    async getAll() {
      const bots = await this.botsService.getByConta(this.getIdContaOrThrow());
      this.bots = bots;
      return bots;
    },

    async delete(id: IdBot) {
      await this.botsService.delete(id);

      const idx = this.bots.findIndex(b => b.id == id);

      if (idx >= 0) {
        this.bots[idx].del = true;
      }
    },

    async restore(id: IdBot) {
      await this.botsService.restore(id);

      const idx = this.bots.findIndex(b => b.id == id);

      if (idx >= 0) {
        this.bots[idx].del = false;
      }
    },

    async getAcoesETransicoes(idBot: IdBot) {
      return await this.botsAcoesService.getAcoesETransicoes(idBot);
    },

    async handleUpload(midia: ConteudoBotAcaoMidia, idInbox: IdInbox) {
      if (!midia.toUpload) return midia.url;
      if (!midia.file) throw new Error('[botStore|handleUpload] File era null.');

      const uploadResponse = await this.storageService.uploadInboxFile({
        file: midia.file,
        idInbox
      });

      return uploadResponse.path;
    },

    async saveAcoesETransicoes(dto: CreateBotsAcoes, idInbox: IdInbox) {
      dto.acoes = await Promise.all(
        dto.acoes.map(async (a) => {
          if (a.tipo == TipoBotAcao.MIDIA) {
            const conteudo = a.conteudo as ConteudoBotAcaoMidia;
            conteudo.url = await this.handleUpload(conteudo, idInbox);
            a.conteudo = {
              url: conteudo.url,
              legenda: conteudo.legenda,
              tamanho: conteudo.tamanho,
              nomeArquivo: conteudo.nomeArquivo,
              tipo: conteudo.tipo,
              aguardarResposta: conteudo.aguardarResposta,
              minutosAguardar: conteudo.minutosAguardar
            };
          }

          return a;
        })
      );

      return await this.botsAcoesService.create(dto);
    },

    getIdContaOrThrow() {
        if (!this.idConta) throw new Error('[botStore] O IdConta era nulo.');
        return this.idConta
    },

    async clonar(idBotOrigem: IdBot, idsInboxesDestino: string[]) {
      const resultado = await this.botsService.clonar(idBotOrigem, idsInboxesDestino);
      await this.getAll();
      return resultado;
    }
  }
});
